import { forwardRef } from 'react'

import careIcons from './svg/care-icons'
import systemIcons from './svg/system-icons'
import largeIcons from './svg/large-icons'
import { IconProps, IconSize, IconType } from './Icon.types'

const iconsByType = {
  care: careIcons,
  system: systemIcons,
  large: largeIcons,
}
const allIcons = { ...iconsByType.care, ...iconsByType.system }

// the forward ref is needed for the modal component button
export const Icon = forwardRef(
  (
    {
      className = '',
      name,
      pathClass,
      size = IconSize.MD,
      type = IconType.SYSTEM,
    }: IconProps,
    forwardedRef: any,
  ) => {
    // by default, icon is pulled from the full list
    // but since there can be different versions for some
    // with the same name, we allow the type to be specified
    let iconComponent = allIcons[name]
    if (/care|system|large/.test(type)) {
      iconComponent = iconsByType[type][name]
    }

    // Sizes come in as t-shirt sizes. Convert that to a number
    // and pass that to be used as h- & w- tailwind values.
    const sizeMap = {
      xxs: 2,
      xs: 3,
      sm: 4,
      md: 6,
      lg: 8,
      xl: 10,
      xxl: 12,
      '3xl': 20,
      '4xl': 40,
    }
    const realSize = sizeMap[size]
    try {
      if (!realSize || !size)
        throw Error(
          `Invalid size for the '${name}' icon. Expected xxs, xs, sm, md, lg, xl, xxl, 3xl, or 4xl.`,
        )

      if (!iconComponent) {
        throw Error(
          `Could not find the '${name}' icon. Make sure 'type' is defined as either "care", "large", or "system" (default) and that your icon exists in that set.`,
        )
      }

      return iconComponent({
        // pointer-events-none prevents Heap from tracking
        // the icon click vs the button click
        className: `shrink-0 pointer-events-none ${className}`,
        pathClass,
        ref: forwardedRef,
        size: realSize,
      })
    } catch (err) {
      console.error(err)
      return null
    }
  },
)
